
			[data-rs-theme~="gintoTheme"] {
					--rs-font-family-title: Inter, BlinkMacSystemFont, -apple-system, Roboto, Helvetica, Arial, sans-serif;
--rs-font-family-body: Inter, BlinkMacSystemFont, -apple-system, Roboto, Helvetica, Arial, sans-serif;
--rs-font-family-monospace: Geist Mono, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
--rs-font-weight-regular: 400;
--rs-font-weight-medium: 500;
--rs-font-weight-semibold: 600;
--rs-font-weight-bold: 700;
--rs-font-weight-extrabold: 800;
--rs-font-weight-black: 900;
--rs-font-size-title-1: 6rem;
--rs-line-height-title-1: 6.25rem;
--rs-font-family-title-1: var(--rs-font-family-title);
--rs-font-weight-title-1: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-1: normal;
--rs-font-size-title-2: 5rem;
--rs-line-height-title-2: 5.25rem;
--rs-font-family-title-2: var(--rs-font-family-title);
--rs-font-weight-title-2: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-2: normal;
--rs-font-size-title-3: 4rem;
--rs-line-height-title-3: 4.25rem;
--rs-font-family-title-3: var(--rs-font-family-title);
--rs-font-weight-title-3: var(--rs-font-weight-extrabold);
--rs-letter-spacing-title-3: normal;
--rs-font-size-title-4: 3.5rem;
--rs-line-height-title-4: 3.75rem;
--rs-font-family-title-4: var(--rs-font-family-title);
--rs-font-weight-title-4: var(--rs-font-weight-bold);
--rs-letter-spacing-title-4: normal;
--rs-font-size-title-5: 3rem;
--rs-line-height-title-5: 3.25rem;
--rs-font-family-title-5: var(--rs-font-family-title);
--rs-font-weight-title-5: var(--rs-font-weight-bold);
--rs-letter-spacing-title-5: normal;
--rs-font-size-title-6: 2.25rem;
--rs-line-height-title-6: 2.5rem;
--rs-font-family-title-6: var(--rs-font-family-title);
--rs-font-weight-title-6: var(--rs-font-weight-bold);
--rs-letter-spacing-title-6: normal;
--rs-font-size-featured-1: 2rem;
--rs-line-height-featured-1: 2.5rem;
--rs-font-family-featured-1: var(--rs-font-family-body);
--rs-letter-spacing-featured-1: normal;
--rs-font-size-featured-2: 1.5rem;
--rs-line-height-featured-2: 2rem;
--rs-font-family-featured-2: var(--rs-font-family-body);
--rs-letter-spacing-featured-2: normal;
--rs-font-size-featured-3: 1.25rem;
--rs-line-height-featured-3: 1.75rem;
--rs-font-family-featured-3: var(--rs-font-family-body);
--rs-letter-spacing-featured-3: normal;
--rs-font-size-body-1: 1.125rem;
--rs-line-height-body-1: 1.75rem;
--rs-font-family-body-1: var(--rs-font-family-body);
--rs-letter-spacing-body-1: normal;
--rs-font-size-body-2: 1rem;
--rs-line-height-body-2: 1.5rem;
--rs-font-family-body-2: var(--rs-font-family-body);
--rs-letter-spacing-body-2: normal;
--rs-font-size-body-3: 0.875rem;
--rs-line-height-body-3: 1.25rem;
--rs-font-family-body-3: var(--rs-font-family-body);
--rs-letter-spacing-body-3: normal;
--rs-font-size-caption-1: 0.75rem;
--rs-line-height-caption-1: 1rem;
--rs-font-family-caption-1: var(--rs-font-family-body);
--rs-letter-spacing-caption-1: normal;
--rs-font-size-caption-2: 0.625rem;
--rs-line-height-caption-2: 0.75rem;
--rs-font-family-caption-2: var(--rs-font-family-body);
--rs-letter-spacing-caption-2: normal;
--rs-unit-base: 4px;
--rs-unit-x1: 4px;
--rs-unit-x2: 8px;
--rs-unit-x3: 12px;
--rs-unit-x4: 16px;
--rs-unit-x5: 20px;
--rs-unit-x6: 24px;
--rs-unit-x7: 28px;
--rs-unit-x8: 32px;
--rs-unit-x9: 36px;
--rs-unit-x10: 40px;
--rs-radius-small: 4px;
--rs-radius-medium: 8px;
--rs-radius-large: 12px;
--rs-color-background-positive: #118850;
--rs-color-brand: #5a58f2;
--rs-color-white: #ffffff;
--rs-color-black: #000000;
--rs-color-brand-primary: #00A6A0;
--rs-color-on-background-primary: oklch(1 0 0);
--rs-color-on-background-critical: oklch(1 0 0);
--rs-color-on-background-warning: oklch(0 0 0);
--rs-color-on-background-positive: oklch(1 0 0);
--rs-color-rgb-background-positive: 17.008499999999998, 135.9915, 79.9935;
--rs-color-on-brand: oklch(1 0 0);
--rs-color-rgb-white: 255, 255, 255;
--rs-color-rgb-black: 0, 0, 0;
--rs-duration-rapid: 100ms;
--rs-duration-fast: 200ms;
--rs-duration-medium: 300ms;
--rs-duration-slow: 400ms;
--rs-easing-standard: cubic-bezier(0.4, 0, 0.2, 1);
--rs-easing-accelerate: cubic-bezier(0.4, 0, 1, 1);
--rs-easing-decelerate: cubic-bezier(0, 0, 0.2, 1);
--rs-shadow-raised: 0px 1px 5px -4px rgba(0, 0, 0, 0.5), 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
--rs-shadow-overlay: 0px 5px 10px 0px rgba(0, 0, 0, 0.05), 0px 15px 25px 0px rgba(0, 0, 0, 0.07);
--rs-viewport-m-min: 660;
--rs-viewport-l-min: 900;
--rs-viewport-xl-min: 1280;
--rs-z-index-relative: 10;
--rs-z-index-absolute: 100;
--rs-z-index-fixed: 200;
			}
		
			[data-rs-theme~="gintoTheme"][data-rs-color-mode="light"] {
					--rs-color-background-primary: #007B76;
--rs-color-background-primary-faded: #D0EDEB;
--rs-color-border-primary: #007B76;
--rs-color-border-primary-faded: #D0EDEB;
--rs-color-foreground-primary: #007B76;
--rs-color-background-critical: #E22C2C;
--rs-color-background-critical-faded: #FFF1EF;
--rs-color-border-critical: #C22022;
--rs-color-border-critical-faded: #f3dad6;
--rs-color-foreground-critical: #C22022;
--rs-color-background-warning: #FACC15;
--rs-color-background-warning-faded: #FFF6DD;
--rs-color-border-warning: #816802;
--rs-color-border-warning-faded: #ece2c4;
--rs-color-foreground-warning: #7B6305;
--rs-color-background-positive-faded: #EBFFF1;
--rs-color-border-positive: #0F7F4A;
--rs-color-border-positive-faded: #d2eddb;
--rs-color-foreground-positive: #0F7F4A;
--rs-color-background-neutral: #E3E4E8;
--rs-color-background-neutral-faded: #f3f3f5;
--rs-color-border-neutral: #0000001F;
--rs-color-border-neutral-faded: #00000015;
--rs-color-foreground-neutral: #2C2E34;
--rs-color-foreground-neutral-faded: #676A75;
--rs-color-background-disabled: #EDEEEF;
--rs-color-background-disabled-faded: #F6F6F7;
--rs-color-border-disabled: #E2E2E4;
--rs-color-foreground-disabled: #CBCCCF;
--rs-color-background-elevation-base: #FFFFFF;
--rs-color-background-elevation-raised: #FFFFFF;
--rs-color-background-elevation-overlay: #FFFFFF;
--rs-color-background-page: #FFFFFF;
--rs-color-background-page-faded: #FAFBFB;
--rs-color-rgb-background-primary: 0, 123.012, 117.9885;
--rs-color-rgb-background-primary-faded: 208.0035, 236.997, 235.00799999999998;
--rs-color-rgb-background-critical: 226.0065, 43.9875, 43.9875;
--rs-color-rgb-background-critical-faded: 255, 241.00050000000002, 239.0115;
--rs-color-rgb-background-warning: 250.002, 204, 21.012;
--rs-color-rgb-background-warning-faded: 255, 245.9985, 221.0085;
--rs-color-rgb-background-positive-faded: 235.00799999999998, 255, 241.00050000000002;
--rs-color-on-background-neutral: oklch(0 0 0);
--rs-color-rgb-background-neutral: 227.001, 227.9955, 231.99900000000002;
--rs-color-rgb-background-neutral-faded: 242.9895, 242.9895, 245.004;
--rs-color-rgb-background-disabled: 236.997, 237.9915, 239.0115;
--rs-color-rgb-background-disabled-faded: 245.9985, 245.9985, 246.993;
--rs-color-rgb-background-elevation-base: 255, 255, 255;
--rs-color-rgb-background-elevation-raised: 255, 255, 255;
--rs-color-rgb-background-elevation-overlay: 255, 255, 255;
--rs-color-rgb-background-page: 255, 255, 255;
--rs-color-rgb-background-page-faded: 250.002, 250.9965, 250.9965;
			}
		
			[data-rs-theme~="gintoTheme"][data-rs-color-mode="dark"] {
					--rs-color-background-primary: #00736F;
--rs-color-background-primary-faded: #112A28;
--rs-color-border-primary: #3D9E99;
--rs-color-border-primary-faded: #1F4341;
--rs-color-foreground-primary: #3D9E99;
--rs-color-background-critical: #D72828;
--rs-color-background-critical-faded: #391B18;
--rs-color-border-critical: #E68075;
--rs-color-border-critical-faded: #5a2e29;
--rs-color-foreground-critical: #E68075;
--rs-color-background-warning: #D7AE06;
--rs-color-background-warning-faded: #2B2410;
--rs-color-border-warning: #EED58A;
--rs-color-border-warning-faded: #453c1e;
--rs-color-foreground-warning: #EED58A;
--rs-color-background-positive-faded: #152A1D;
--rs-color-border-positive: #57B17C;
--rs-color-border-positive-faded: #264431;
--rs-color-foreground-positive: #57B17C;
--rs-color-background-neutral: #393A42;
--rs-color-background-neutral-faded: #222835;
--rs-color-border-neutral: #FFFFFF24;
--rs-color-border-neutral-faded: #FFFFFF15;
--rs-color-foreground-neutral: #F3F3F5;
--rs-color-foreground-neutral-faded: #C7C9D1;
--rs-color-background-disabled: #242527;
--rs-color-background-disabled-faded: #1B1B1D;
--rs-color-border-disabled: #262729;
--rs-color-foreground-disabled: #494A4E;
--rs-color-background-elevation-base: #161617;
--rs-color-background-elevation-raised: #18191A;
--rs-color-background-elevation-overlay: #1D1D1F;
--rs-color-background-page: #0E0E0F;
--rs-color-background-page-faded: #131414;
--rs-color-rgb-background-primary: 0, 115.00500000000001, 111.00150000000001;
--rs-color-rgb-background-primary-faded: 17.008499999999998, 41.9985, 40.0095;
--rs-color-rgb-background-critical: 214.9905, 40.0095, 40.0095;
--rs-color-rgb-background-critical-faded: 56.9925, 27.0045, 23.9955;
--rs-color-rgb-background-warning: 214.9905, 174.012, 5.9925;
--rs-color-rgb-background-warning-faded: 42.993, 36.006, 15.988500000000002;
--rs-color-rgb-background-positive-faded: 21.012, 41.9985, 28.993499999999997;
--rs-color-on-background-neutral: oklch(1 0 0);
--rs-color-rgb-background-neutral: 56.9925, 58.0125, 65.994;
--rs-color-rgb-background-neutral-faded: 33.9915, 40.0095, 52.989000000000004;
--rs-color-rgb-background-disabled: 36.006, 37.0005, 38.9895;
--rs-color-rgb-background-disabled-faded: 27.0045, 27.0045, 28.993499999999997;
--rs-color-rgb-background-elevation-base: 22.0065, 22.0065, 23.001;
--rs-color-rgb-background-elevation-raised: 23.9955, 24.990000000000002, 26.009999999999998;
--rs-color-rgb-background-elevation-overlay: 28.993499999999997, 28.993499999999997, 31.008;
--rs-color-rgb-background-page: 13.9995, 13.9995, 14.994;
--rs-color-rgb-background-page-faded: 18.9975, 19.992, 19.992;
			}
		